import { render, staticRenderFns } from "./ConsultingClientRights.vue?vue&type=template&id=9008f516"
import script from "./ConsultingClientRights.vue?vue&type=script&lang=js"
export * from "./ConsultingClientRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports